import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap5';

import { useContext as useTemplatesContext } from 'components/Managers/Templates/Context';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Template from './Template';

export default function Templates({ mainAction }) {
  const { dispatch: dispatchTemplates, actions: actionsTemplates, state: stateTemplates } = useTemplatesContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    actionsTemplates.load(dispatchTemplates, stateTemplates.enterpriseId, () => setLoading(false));
  }, []);

  return (
    <section>
      {loading ? (
        <LoadingPlaceholder text="Loading programs..." />
      ) : (
        <Row>
          {
          stateTemplates.templates.map(
            (template) => <Template key={`template-${template.id}`} template={template} mainAction={mainAction} />,
          )
        }
        </Row>
      )}
    </section>
  );
}

Templates.propTypes = {
  mainAction: PropTypes.string,
};

Templates.defaultProps = {
  mainAction: 'assign',
};
